 var swiper = new Swiper(".mySwiper", {
      direction: 'vertical', 
      spaceBetween: 8,
      slidesPerView: 4,
      watchSlidesProgress: true,
    });
    var swiper2 = new Swiper(".mySwiper2", {
      spaceBetween: 8,
      thumbs: {
        swiper: swiper,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // Makes pagination bullets clickable
      },
    });